// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EiN2CJ6xisE2ltZHukyn{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
}
._1R41CmvonpK4CJeVRLn {
  margin: var(--spacing-xxSmall);
}

.tuxXosC_st91b_HEaIH_ {
  width: 400px;
}
`, "",{"version":3,"sources":["webpack://./src/App/views/Error/Error.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd","sourcesContent":[".container-card-empty{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100vh;\n}\n.card-empty {\n  margin: var(--spacing-xxSmall);\n}\n\n.card-description {\n  width: 400px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container-card-empty": `EiN2CJ6xisE2ltZHukyn`,
	"card-empty": `_1R41CmvonpK4CJeVRLn`,
	"card-description": `tuxXosC_st91b_HEaIH_`
};
export default ___CSS_LOADER_EXPORT___;
